import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-ele-bg text-ele-body">
      <h1 className="font-heading text-4xl">Page not found</h1>
      <Link to="/" className="text-ele-green">
        Back to start
      </Link>
    </div>
  );
}
